export interface StatusMeta {
  value: string;
  label: string;
  group: "requested" | "preparing" | "shipping" | "done" | "issue" | "neutral";
  tone: "blue" | "amber" | "purple" | "green" | "red" | "gray";
}

export const REQUEST_STATUS_OPTIONS: StatusMeta[] = [
  { value: "requested", label: "신청완료", group: "requested", tone: "blue" },
  { value: "preparing", label: "배송준비", group: "preparing", tone: "amber" },
  { value: "rider_assigned", label: "배송준비", group: "preparing", tone: "amber" },
  { value: "shipping", label: "배송중", group: "shipping", tone: "purple" },
  { value: "delivered", label: "배송완료", group: "done", tone: "green" },
  { value: "received_confirmed", label: "수령확인", group: "done", tone: "green" },
  { value: "survey_completed", label: "설문완료", group: "done", tone: "green" },
  { value: "fulfilled", label: "최종완료", group: "done", tone: "green" },
  { value: "not_received_reported", label: "배송 문제", group: "issue", tone: "red" },
  { value: "confirmation_expired", label: "수령확인 만료", group: "issue", tone: "red" },
  { value: "cancelled", label: "신청취소", group: "issue", tone: "red" },
  { value: "cancelled_by_consumer", label: "신청취소", group: "issue", tone: "red" },
  { value: "cancelled_by_admin", label: "관리자 취소", group: "issue", tone: "red" },
  { value: "cancelled_product_deleted", label: "상품 운영중단", group: "issue", tone: "red" },
  { value: "cancelled_campaign_deleted", label: "샘플 운영중단", group: "issue", tone: "red" },
  { value: "delivery_cancelled", label: "배송취소", group: "issue", tone: "red" },
  { value: "delivery_failed", label: "배송실패", group: "issue", tone: "red" },
  { value: "rejected", label: "신청반려", group: "issue", tone: "red" },
];

const STATUS_MAP = new Map(REQUEST_STATUS_OPTIONS.map((item) => [item.value, item]));

export const QUICK_STATUS_ACTIONS = [
  "requested",
  "preparing",
  "rider_assigned",
  "shipping",
  "delivered",
  "received_confirmed",
  "survey_completed",
  "not_received_reported",
  "delivery_cancelled",
  "delivery_failed",
  "rejected",
] as const;

export function getRequestStatusMeta(status: string): StatusMeta {
  return (
    STATUS_MAP.get(status) ?? {
      value: status,
      label: status || "미확인",
      group: "neutral",
      tone: "gray",
    }
  );
}

export function getRequestStatusLabel(status: string): string {
  return getRequestStatusMeta(status).label;
}

export function getRequestStatusClass(status: string): string {
  return `status status-${getRequestStatusMeta(status).tone}`;
}

export function getCampaignStatusLabel(status: string): string {
  return (
    {
      draft: "초안",
      pending: "승인대기",
      active: "진행중",
      paused: "일시중지",
      completed: "완료",
      archived: "보관",
      rejected: "반려",
    }[status] ?? status
  );
}

export function getPayoutStatusLabel(status: string | null | undefined): string {
  if (status === "paid") return "입금완료";
  if (status === "pending") return "정산대기";
  return status || "정산대기";
}
